import { render, staticRenderFns } from "./dati.vue?vue&type=template&id=f724b164&"
import script from "./dati.vue?vue&type=script&lang=js&"
export * from "./dati.vue?vue&type=script&lang=js&"
import style0 from "./dati.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports